/**
 * lib/liveAnalyticsApi.js — thin axios wrapper for Live Class Analytics.
 */
import api, { formatApiError } from "./api";

export async function getLiveAnalyticsDashboard({
  lookbackDays = 30,
  eventId = null,
} = {}) {
  const params = new URLSearchParams();
  params.set("lookback_days", String(lookbackDays));
  if (eventId) params.set("event_id", eventId);
  return (
    await api.get(`/lms/live-sessions/analytics/dashboard?${params.toString()}`)
  ).data;
}

export function liveAnalyticsCsvUrl({ lookbackDays = 30 } = {}) {
  const params = new URLSearchParams();
  params.set("lookback_days", String(lookbackDays));
  return `/lms/live-sessions/analytics/export.csv?${params.toString()}`;
}

export { formatApiError };
